<template>
    <Paper class="detailsNotice">
        <div class="notice-title">
            <span class="notice-title-item1"></span>
            <span class="notice-title-item2">{{+noticeMain.contentType===1?'公告详情':'问题详情'}}</span>
        </div>
        <div class="notice-main">
            <div class="notice-main-top">
                <div class="notice-main-top-item1">{{noticeMain.title}}</div>
                <div class="notice-main-top-item2" v-show="check">
                    <span class="notice-main-top-item2-title">附件:</span>
                    <el-link class="notice-accessory-main" :href="noticeMain.link" >{{noticeMain.ossEndpoint}}</el-link>
                </div>
            </div>
            <div class="notice-main-bottom ql-editor"></div>
        </div>
    </Paper>
</template>
<script>
import Paper from '@/components/core/paper/Paper';
import { searchNoticOnce } from '../../../api/systemManagementApi';
export default {
    data() {
        return {
            noticeMain: {
                title: '123',
                ossEndpoint: '',
                link: '',
                main: '',
                contentType: '1'
            },
            check: false
        };
    },
    methods: {
        getPull(id) {
            searchNoticOnce(id).then(res => {
                if (res.code === '0') {
                    this.noticeMain.title = res.data.subject;
                    this.noticeMain.ossEndpoint = res.data.ossEndpoint;
                    if (res.data.ossEndpoint !== '暂无上传附件') {
                        this.check = true;
                    }
                    this.noticeMain.link = res.data.link;
                    this.noticeMain.contentType = res.data.contentType;
                    document.getElementsByClassName('notice-main-bottom')[0].innerHTML = res.data.content;
                }
            });
        },
        downloadMain() {
            this.link.click();
        }
    },
    components: {
        Paper
    },
    created() {
        if (this.$route.query.id) {
            this.getPull(this.$route.query.id);
        } else {
            this.$router.push({
                path: '/homePage'
            });
        }
    }
};
</script>
<style lang="less">
.detailsNotice{
    .notice-title{
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        .notice-title-item1{
                width: 2px;
                height: 18px;
                margin-right: 10px;
                background-color: #4285f5;
        }
        .notice-title-item2{
            font-size: 16px;
            color: #262626;
            text-align: left;
            font-weight: 500;
        }
    }
    .notice-main{
        border: 1px solid #D9D9D9;
        border-radius: 5px;
        overflow: auto;
    }
    .notice-main-top{
        background: #F5F5F5;
        height: 48px;
        border-bottom: 1px solid #D9D9D9;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 20px;
        font-size: 14px;
    }
    .notice-main-bottom{
        width: 100%;
        height:  calc(100vh - 230px);
        box-sizing: border-box;
        overflow: auto;
        padding:20px;
        font-size: 14px;
        color: rgba(0,0,0,0.65);
        text-align: left;
        line-height: 22px;
    }
    .notice-main-top-item1{
        font-size: 14px;
        color: #262626;
        text-align: left;
        line-height: 22px;
        font-weight: 500;
        width: 72%;
    }
    .notice-main-top-item2{
        display: flex;
    }
    .notice-main-top-item2-title{
        margin-right: 10px;
        color: rgba(0,0,0,0.45);
        text-align: right;
        width: 40px;
    }
    .notice-accessory-main{
        font-size: 14px;
        color: #4285f5;
    }
}
</style>